import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Swal from 'sweetalert2';
import '../css/MembershipRegistration.css';
import axios from 'axios';
import * as Constants from '../Constants/Constants';

const MembershipRegistration = () => {

    const [amount, setAmount] = useState(0);

  
    const [formData, setFormData] = useState({
        membershipType: "Select",
        memberName: "",
        mobileNumber: "",
        email: "",
        dob: "",
        admissionYear: "",
        exitYear: "",
        qualification: "",
        communicationAddress: "",
        permanentAddress: "",
        workplace: "",
        positionHeld: "",
        declarationYear: "",
        declarationAccepted: false,
    });
    const checkEmptyFields = () => {
        for (const [key, value] of Object.entries(formData)) {
            if (value === '' || value === null || value === undefined) {
                console.log(`Field "${key}" is empty.`);
                return true; // Return true if any field is empty
            }
        }
        return false; // Return false if all fields are filled
    };

    function customAlert(type,text){
        alert("Please select a valid membership type.");
        Swal.fire({
          icon: type, // Indicates an error
          title: 'Oops...',
          text: text, // Your custom message
          customClass: {
            popup: 'custom-swal', // Use custom class for styling
          },
          showCloseButton: true, // Show close button
          showCancelButton: false, // Optionally show a cancel button
        });
    }

    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: currentYear - 1967 + 1 }, (_, index) => 1967 + index);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === "checkbox" ? checked : value,
        }));

        if (name === "membershipType" && value === "Chief Patron") {
            setAmount(25000);
            
        }
        else if(name === "membershipType" && value === "Patron"){
            setAmount(10000);

        }else if(name === "membershipType" && value === "Life Member"){
            setAmount(2500);

        }
    };

    async function  handleSubmit (e) {
      e.preventDefault();

      if (formData.membershipType === "Select") {
        customAlert('error','Please select member type');
          return;
      }

    const phoneRegex = /^(?:(?:\+91|91|0)?[789]\d{9})$/;
     // Validate phone number
     if (!phoneRegex.test(formData.mobileNumber)) {
        customAlert('error','invalid phone number')
          return;
      }
     
      // Log form data to the console
      console.log("Membership Type:", formData.membershipType);
      console.log("Member Name:", formData.memberName);
      console.log("Mobile Number:", formData.mobileNumber);
      console.log("Email:", formData.email);
      console.log("Date of Birth:", formData.dob);
      console.log("Year of Admission:", formData.admissionYear);
      console.log("Year of Exit:", formData.exitYear);
      console.log("Qualification:", formData.qualification);
      console.log("Communication Address:", formData.communicationAddress);
      console.log("Permanent Address:", formData.permanentAddress);
      console.log("Workplace:", formData.workplace);
      console.log("Position Held:", formData.positionHeld);
      console.log("Declaration Year:", formData.declarationYear);
      console.log("Declaration Accepted:", formData.declarationAccepted);

      const payload = {
        userName: formData.memberName,
        email: formData.email,
        mobile: formData.mobileNumber,
        com_adds: formData.communicationAddress,
        perm_adds: formData.permanentAddress,
        working: formData.workplace,
        year_join: formData.admissionYear,
        year_end: formData.exitYear,
        qualification: formData.qualification,
        position: formData.positionHeld,
        dob: formData.dob,
        member_type: formData.membershipType,
    };





   

    //razorPay implimentation

  

    var options = {
        key: "rzp_test_xxxBYaLwXFq6nL",
        key_secret: "tQduw7TF6KShUloM4R2UKZmZ",
        amount: parseInt(amount) * 100,
        currency: "INR",
        name: "Kusavini Balaga",
        description: `Payment for Kusavini ${formData.membershipType}`,
        prefill: {
            name: formData.memberName,
            email: formData.email,
            contact: formData.mobileNumber,
          },
        handler: async function (response) {
            console.log("Pay:",response);
          const paymentId = response.razorpay_payment_id;
          console.log("paymant id", paymentId);
          const payload2 = {
            userName: formData.memberName,
            email: formData.email,
            mobile: formData.mobileNumber,
            com_adds: formData.communicationAddress,
            perm_adds: formData.permanentAddress,
            working: formData.workplace,
            year_join: formData.admissionYear,
            year_end: formData.exitYear,
            qualification: formData.qualification,
            position: formData.positionHeld,
            dob: formData.dob,
            member_type: formData.membershipType,
            payment_Id:paymentId,
        };
          try {
            // Make the POST request
            const response = await axios.post(`${Constants.BASE_URL}?apitype=201`, payload2);
            console.log("reg:",response);
    
            if (response.data.status) {
                Swal.fire({
                    icon: 'success',
                    title: 'Registration Successful',
                    text: response.data.message || 'User registered successfully!',
                    confirmButtonText: 'OK'
                });
    
                setFormData({
                    membershipType: "Select",
                    memberName: "",
                    mobileNumber: "",
                    email: "",
                    dob: "",
                    admissionYear: "",
                    exitYear: "",
                    qualification: "",
                    communicationAddress: "",
                    permanentAddress: "",
                    workplace: "",
                    positionHeld: "",
                    declarationYear: "",
                    declarationAccepted: false,
                });
    
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Registration Failed',
                    text: response.data.message || 'An error occurred while registering the user.',
                    confirmButtonText: 'OK'
                });
            }
    
        } catch (error) {
            console.error('Error registering user:', error);
    
            // Display error message
            Swal.fire({
                icon: 'error',
                title: 'Registration Failed',
                text: error.response?.data?.message || 'An error occurred while registering the user.',
                confirmButtonText: 'OK'
            });
        }    
       
        },
        theme: {
          color: "#07a291db",
        },
      };
      var pay = new window.Razorpay(options);
      pay.open();
    
  };

 

    return (
        <div className="container mt-5">
            <h2 className="text-center mb-4">Membership Registration</h2>
            <form onSubmit={handleSubmit}>

                {/* Membership Type */}
                <div className="form-group row mb-3">
                    <label htmlFor="membershipType" className="col-sm-4 col-form-label">Type of Membership</label>
                    <div className="col-sm-8">
                        <select
                            name="membershipType"
                            id="membershipType"
                            className="form-control"
                            value={formData.membershipType}
                            onChange={handleChange}
                        >
                            <option value="Select">Select</option>
                            <option value="Chief Patron">Chief Patron</option>
                            <option value="Patron">Patron</option>
                            <option value="Life Member">Life Member</option>
                        </select>
                    </div>
                </div>

                {/* Member Name */}
                <div className="form-group row mb-3">
                    <label htmlFor="memberName" className="col-sm-4 col-form-label">Name of the Member</label>
                    <div className="col-sm-8">
                        <input
                            type="text"
                            className="form-control"
                            name="memberName"
                            id="memberName"
                            value={formData.memberName}
                            onChange={handleChange}
                            required
                        />
                    </div>
                </div>

                {/* Mobile Number */}
                <div className="form-group row mb-3">
                    <label htmlFor="mobileNumber" className="col-sm-4 col-form-label">Mobile Number</label>
                    <div className="col-sm-8">
                        <input
                            type="tel"
                            className="form-control"
                            name="mobileNumber"
                            id="mobileNumber"
                            value={formData.mobileNumber}
                            onChange={handleChange}
                            pattern="[0-9]{10}"
                            placeholder="10-digit Indian number"
                            required
                        />
                    </div>
                </div>

                {/* Email Address */}
                <div className="form-group row mb-3">
                    <label htmlFor="email" className="col-sm-4 col-form-label">Email Address</label>
                    <div className="col-sm-8">
                        <input
                            type="email"
                            className="form-control"
                            name="email"
                            id="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />
                    </div>
                </div>

                {/* Date of Birth */}
                <div className="form-group row mb-3">
                    <label htmlFor="dob" className="col-sm-4 col-form-label">Date of Birth (dd-MM-yyyy)</label>
                    <div className="col-sm-8">
                        <input
                            type="date"
                            className="form-control"
                            name="dob"
                            id="dob"
                            value={formData.dob}
                            onChange={handleChange}
                            required
                        />
                    </div>
                </div>

                {/* Year of Admission */}
                <div className="form-group row mb-3">
                    <label htmlFor="admissionYear" className="col-sm-4 col-form-label">Year of Admission</label>
                    <div className="col-sm-8">
                        <select
                            name="admissionYear"
                            id="admissionYear"
                            className="form-control"
                            value={formData.admissionYear}
                            onChange={handleChange}
                            required
                        >
                            {years.map((year) => (
                                <option key={year} value={year}>{year}</option>
                            ))}
                        </select>
                    </div>
                </div>

                {/* Year of Exit */}
                <div className="form-group row mb-3">
                    <label htmlFor="exitYear" className="col-sm-4 col-form-label">Year of Exit</label>
                    <div className="col-sm-8">
                        <select
                            name="exitYear"
                            id="exitYear"
                            className="form-control"
                            value={formData.exitYear}
                            onChange={handleChange}
                            required
                        >
                            {years.map((year) => (
                                <option key={year} value={year}>{year}</option>
                            ))}
                        </select>
                    </div>
                </div>

                {/* Qualification */}
                <div className="form-group row mb-3">
                    <label htmlFor="qualification" className="col-sm-4 col-form-label">Qualification</label>
                    <div className="col-sm-8">
                        <input
                            type="text"
                            className="form-control"
                            name="qualification"
                            id="qualification"
                            value={formData.qualification}
                            onChange={handleChange}
                            required
                        />
                    </div>
                </div>

                {/* Communication Address */}
                <div className="form-group row mb-3">
                    <label htmlFor="communicationAddress" className="col-sm-4 col-form-label">Communication Address</label>
                    <div className="col-sm-8">
                        <textarea
                            className="form-control"
                            name="communicationAddress"
                            id="communicationAddress"
                            value={formData.communicationAddress}
                            onChange={handleChange}
                            rows="3"
                            required
                        />
                    </div>
                </div>

                {/* Permanent Address */}
                <div className="form-group row mb-3">
                    <label htmlFor="permanentAddress" className="col-sm-4 col-form-label">Permanent/Native Address</label>
                    <div className="col-sm-8">
                        <textarea
                            className="form-control"
                            name="permanentAddress"
                            id="permanentAddress"
                            value={formData.permanentAddress}
                            onChange={handleChange}
                            rows="3"
                            required
                        />
                    </div>
                </div>

                {/* Where you are working? */}
                <div className="form-group row mb-3">
                    <label htmlFor="workplace" className="col-sm-4 col-form-label">Where you are working?</label>
                    <div className="col-sm-8">
                        <input
                            type="text"
                            className="form-control"
                            name="workplace"
                            id="workplace"
                            value={formData.workplace}
                            onChange={handleChange}
                            required
                        />
                    </div>
                </div>

                {/* Position Held */}
                <div className="form-group row mb-3">
                    <label htmlFor="positionHeld" className="col-sm-4 col-form-label">Position Held</label>
                    <div className="col-sm-8">
                        <input
                            type="text"
                            className="form-control"
                            name="positionHeld"
                            id="positionHeld"
                            value={formData.positionHeld}
                            onChange={handleChange}
                            required
                        />
                    </div>
                </div>

                {/* Declaration */}
                {/* <div className="form-group row mb-3">
                    <div className="col-sm-12">
                        <p>
                            I, Sri hereby declare that, I had officially stayed with boarding & lodging facility at KUNCHITIGARA SARVAJANIKA VIDYARTHI (KSV) NILAYA, #46, Near Ayyappa Swamy Temple, Miller’s Road, Vasanthnagar, Bengaluru – 560052, during the year 
                           . My stay in the hostel exceeds the period of one month and I am officially eligible in all the respects to be a member of KUSAVINI BALAGA. And I agreed to follow the rules, terms and conditions of KUSAVINI BALAGA.
                        </p>
                        <div className="form-check">
                            <input
                                type="checkbox"
                                className="form-check-input"
                                name="declarationAccepted"
                                id="declarationAccepted"
                                checked={formData.declarationAccepted}
                                onChange={handleChange}
                                required
                            />
                            <label className="form-check-label" htmlFor="declarationAccepted">I accept the declaration</label>
                        </div>
                    </div>
                </div> */}
               <div className="form-group row mb-3">
    <div className="col-sm-12">
        <p>
            I, Sri hereby declare that, I had officially stayed with boarding & lodging facility at KUNCHITIGARA SARVAJANIKA VIDYARTHI (KSV) NILAYA, #46, Near Ayyappa Swamy Temple, Miller’s Road, Vasanthnagar, Bengaluru – 560052, during the year.
            My stay in the hostel exceeds the period of one month and I am officially eligible in all the respects to be a member of KUSAVINI BALAGA. And I agreed to follow the rules, terms and conditions of KUSAVINI BALAGA.
        </p>
        <div className="form-check mt-3 p-3 d-flex justify-content-center align-items-center" style={{ backgroundColor: '#f0f8ff', border: '2px solid #007bff', borderRadius: '5px' }}>
            <input
                type="checkbox"
                className="form-check-input"
                name="declarationAccepted"
                id="declarationAccepted"
                checked={formData.declarationAccepted}
                onChange={handleChange}
                required
                style={{ transform: 'scale(1.3)', marginRight: '10px' }} // Make checkbox bigger
            />
            <label
                className="form-check-label fw-bold" // Makes the label bold
                htmlFor="declarationAccepted"
                style={{ fontSize: '1.1rem', color: '#007bff' }} // Highlight label with color and larger font
            >
                I accept the declaration
            </label>
        </div>
    </div>
</div>


                {/* Submit Button */}
                <div className="form-group row mb-3">
                    <div className="col-sm-12 text-center">
                        <button type="submit" className="btn btn-primary">Submit</button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default MembershipRegistration;
